import { z } from 'zod';
import { PHONE_ERROR_MESSAGE, PHONE_PATTERN } from './policies/phone.js';
/**
 * Phone number — E.164 format.
 *
 * Wire format regex: `^\+[1-9]\d{1,14}$`
 *
 * - Begins with `+`
 * - Followed by a non-zero leading digit `[1-9]`
 * - Followed by 1 to 14 additional digits (total 2-15 digits after `+`)
 *
 * No separators, no extension, no leading zero, no whitespace.
 */
export const phoneSchema = z
    .string()
    .regex(PHONE_PATTERN, PHONE_ERROR_MESSAGE)
    .brand();
//# sourceMappingURL=phone.js.map